function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

$(function () {
  $('#top-slider')
    .slick({
      autoplay: true,
      //自動スライド
      slidesToShow: 1,
      loop: 1,
      autoplaySpeed: 4000,
      //スライドさせる間隔
      dots: true,
      //ドットインジケーターを表示
      dotsClass: 'top-slider-dots',
      lazyLoad: 'progressive',
      //画像の遅延読み込み
      arrows: false,
      //スライドの左右の矢印ボタンを非表示
      cssEase: 'cubic-bezier(0.9, 0.03, 0.4, 0.9)',
      //CSS3アニメーションイージングを設定
      pauseOnHover: false,
    })
    .on('afterChange', function (event, slick, currentSlide, nextSlide) {
      switch (currentSlide) {
        case 0:
          // 1枚目のスライド
          $(this).slick('slickSetOption', 'autoplaySpeed', 4000);
          break;

        default:
          // その他のスライド
          $(this).slick('slickSetOption', 'autoplaySpeed', 20000);
          ytPlayer[currentSlide - 1].seekTo(0);
          ytPlayer[currentSlide - 1].playVideo();
          break;
      }
    });
});
var tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag); // 各プレーヤーの格納

var ytPlayer = []; // 各動画情報

var ytData = [
  {
    id: 'lEZPLqsmt1s',
    area: 'axis',
  },
  {
    id: 'idj8grMFI48',
    area: 'bright',
  },
  // {
  //   id: 'zbNfOk54KaI',
  //   area: 'axis-sp',
  // },
  // {
  //   id: 'TxTqz5C67zA',
  //   area: 'bright-sp',
  // },
]; // 各プレーヤーの埋め込み



function onYouTubeIframeAPIReady() {
  for (var i = 0; i < ytData.length; i++) {
    var _playerVars;

    ytPlayer[i] = new YT.Player(ytData[i]['area'], {
      height: '100%',
      width: '100%',
      playerVars:
        ((_playerVars = {
          start: 0,
          rel: 0,
          loop: 1,
          playlist: ytData[i]['id'],
        }),
        _defineProperty(_playerVars, 'loop', 1),
        _defineProperty(_playerVars, 'controls', 0),
        _defineProperty(_playerVars, 'autoplay', 1),
        _defineProperty(_playerVars, 'showinfo', 0),
        _defineProperty(_playerVars, 'rel', 0),
        _defineProperty(_playerVars, 'start', 0),
        _defineProperty(_playerVars, 'videoId', ytData[i]['id']),
        _playerVars),
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  }
}

function onPlayerReady(event) {
  // event.target.playVideo();
  event.target.mute();
}

function onPlayerStateChange(event) {
  switch (event.data) {
    case YT.PlayerState.ENDED:
      break;
    case YT.PlayerState.PLAYING:
      break;
    case YT.PlayerState.PAUSED:
      //動画が一時停止されたときに即座に「playVideo()」を実行して
      //一時停止ができないようにする。
      event.target.playVideo();
      break;
    case YT.PlayerState.BUFFERING:
      break;
    case YT.PlayerState.CUED:
      break;
  }
}

